import script from "./PersonalInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalInformation.vue?vue&type=script&setup=true&lang=js"

import "./PersonalInformation.vue?vue&type=style&index=0&id=37cb0ec8&scoped=true&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37cb0ec8"]])

export default __exports__